import React, { Component, Fragment, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import axios from 'axios'

import Main from './components/Main';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './components/Login';
import LoginSAML from './components/LoginSAML';
import LogoutSAML from './components/LogoutSAML';

import ResetPassword from './components/ResetPassword';

import Certificate from './components/Certificate';
import Auth from "./components/Auth";

import Workshop from './components/Workshop';
import Workshops from './components/Workshops';
import Administration from './components/admin/Administration';
import ProtectedRoute from './components/ProtectedRoute.js';

import Dashboard from './components/dashboard/Dashboard';
import User from './components/User';

import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
//import IpaySuccess, {IpayFailure} from './components/IpayLandingPage';
import EMarketStorefrontReturn from './components/EMarketStorefrontReturn';
import WorkshopView from './components/WorkshopView';
import WorkshopWaive from './components/WorkshopWaive';
import SelectCourse from './components/training/SelectCourse';
import SelectCourseZoom from './components/training/SelectCourseZoom';
import SelectCourseDVD from './components/training/SelectCourseDVD';
import Articulate from './components/LMS/Articulate';
import Training from './components/LMS/Training';
import ViewSubModule from './components/LMS/ViewSubModule';
import Quiz from './components/LMS/Quiz';
import ViewQuiz from './components/LMS/ViewQuiz';
import ReviewQuiz from './components/LMS/ReviewQuiz';
import EnterCode from './components/training/EnterCode';
import ZoomClass from './components/training/ZoomClass';

import ScrollToTop from './components/helper/ScrollToTop';

import forgotPassword from './components/ForgotPassword';

import { IdleTimer } from './IdleTimer1'
import IdleDialog  from './components/helper/IdleDialog'
import { authContext } from "./context/AuthContext";

import ErrorBoundary from './components/helper/ErrorBoundary';


const styles = theme => ({
});

class App extends Component {
    static contextType = authContext;

    constructor() {

        super();
        this.idleTimer = null
        this.state = {
            mainError: '',
            timeout:1000 * 5 * 1,
            showIdleDlg: false,
            userLoggedIn: false,
            isTimedOut: false
        }
    }

    componentDidMount() {
        // intercept all http response to perform global error handling
        // Add a request interceptor
        axios.interceptors.request.use(this.initRequest, this.handleError);

        // Add a response interceptor
        axios.interceptors.response.use(function (response) {
            return response;
        }, this.handleError);

        // IIdleTimer interface available on the reference to the IdleTimer component instance
        //https://github.com/SupremeTechnopriest/react-idle-timer/issues/276
        let token = sessionStorage.getItem('accessToken');

        console.log("authenticated: " + token)
        if (token) {
            console.log("starting timer");
            setTimeout(() => {
                 this.idleTimer.start()
            });
        }
       
        // console.log(this.idleTimer);
    }

    initRequest = (config) => {
        // Do something before request is sent
        if (this.state.mainError.length > 0)
            this.setState({ mainError: '' })
        return config;
    }

    handleError = (err) => {
        console.log("error:" + err);
        this.setState({
            mainError: err.response ? err.response.statusText + ', ' + err.message : err.message
        });

        return Promise.reject(err);
    }

    resetError = () => {
        this.setState({ mainError: '' })
    }


    onPrompt = () => {
        // Fire a Modal Prompt
        console.log("onPrompt")
        this.setState({
            showIdleDlg:true
        })
    }

    onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        console.log('onIdle')
        this.onLogout()
          // const isTimedOut = this.state.isTimedOut
          // if (isTimedOut) {
          //     this.props.history.push('/')
          // } else {
          //   this.setState({showModal: true})
          //   this.idleTimer.reset();
          //   this.setState({isTimedOut: true})
          // }

    }

    onActive = (event) => {
        // Close Modal Prompt
       //  console.log('user is active')
      // this.setState({isTimedOut: false})
       this.setState({
          showIdleDlg:false
        })
    }

    onAction = (event) => {
        // Do something when a user triggers a watched event
       // console.log('user did something')
      // this.setState({isTimedOut: false})
       // this.setState({
       //    showIdleDlg:false
       //  })
    }
    onStay = (event) => {
        // Do something when a user triggers a watched event
        console.log("onStay")
        this.idleTimer.reset()
        this.setState({
          showIdleDlg:false
        })
        this.idleTimer.start()
        console.log("time idle", this.idleTimer.getTotalIdleTime())
        console.log("time elapsed", this.idleTimer.getElapsedTime())
        console.log("time active", this.idleTimer.getLastActiveTime())
        console.log("time last idle", this.idleTimer.getLastIdleTime())
        console.log("time remaining", this.idleTimer.getRemainingTime())

    }
    onLogout = (event) => {
        // Do something when a user triggers a watched event
        console.log("App onLogout")
        
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("roles");
        sessionStorage.removeItem('userTrack');
        // clean up cache
        sessionStorage.removeItem('previousSearch');
        sessionStorage.removeItem('previousSearchData');
        sessionStorage.removeItem('selectedEmployer');
        sessionStorage.removeItem('selectedEmployerMembership');
        sessionStorage.removeItem('adminSelectedEmployer');
        sessionStorage.removeItem('previousSearchVT');
        sessionStorage.removeItem('previousSearchDataViewTransactions');
        sessionStorage.removeItem('previousSearchDateVT');
        sessionStorage.removeItem('adminSelectedEmployer');


        let saml = this.context.logout();
        if (saml) {
            this.props.history.replace('/logoutSAML');

        }
        // TODO: logout
      //  this.idleTimer.logout()
        // let saml = this.context.logout();
        // console.log(saml);
        // if (saml) {
        //     this.props.history.replace('/logoutSAML');

        // }
        this.setState({
            showIdleDlg:false
        })
        window.location.reload(false);

    }
    
    render() {
        let userDetails = JSON.parse(sessionStorage.getItem('user'))
        let gatorLinkUser = userDetails ? userDetails.gatorlink : false
        return (
            <ErrorBoundary>

                <Suspense fallback={<h1>loading...</h1>}>

                    <Router basename='/'>                    
                        <Auth>

                            <Fragment>
                                {
                                    gatorLinkUser
                                    ?
                                    <></>
                                    :
                                    <IdleTimer
                                        ref={ref => { this.idleTimer = ref }}
                                        timeout={3300000}
                                        promptTimeout={300000}
                                        onPrompt={this.onPrompt}
                                        onIdle={this.onIdle}
                                        onAction={this.onAction}
                                        onActive={this.onActive}
                                        startManually
                                    />
                                }
                                <Box minWidth="320px">
                                    <a style={{color: '#FFF', background: '#0021a5'}} href="#maincontent">Skip to main content</a>
                                    <Header history={this.props.history}/>
                                    <Box role="main" id="maincontent" mx={(window.innerWidth < 650) ? 4 : 8} mt={3} mb={10}>
                                        {this.state.mainError &&
                                            <div>
                                                <Alert severity="error" onClose={this.resetError}>{this.state.mainError}</Alert>
                                                <br />
                                            </div>
                                        }
                                        <ScrollToTop />

                                        <Switch>
                                            <Route exact={true} path="/" component={Main} />
                                            <Route exact={true} path="/login" component={Login} />
                                            <Route exact={true} path="/loginSAML" component={LoginSAML} />
                                            <Route exact={true} path="/logoutSAML" component={LogoutSAML} />
                                            <Route path="/user" component={User} />
                                            <Route path="/certified" component={Certificate} />

                                            <Route path="/classes" component={Workshops} />
                                            {/* These may need to get deleted if will not be used */}
                                            <ProtectedRoute path="/class/:id/waive" component={WorkshopWaive} />
                                            {/* For the below, Workshop was eventually going to be replaced be WorkshopEdit, which is not done so holding off */}
                                            <ProtectedRoute path="/class/:id/edit" component={Workshop} />
                                            <Route path="/class/:id/view" component={WorkshopView} />

                                            <Route path="/class/:id" component={Workshop} />
                                            <Route path="/class" component={Workshop} />
                                            
                                            <Route path="/administration" component={Administration} />
                                            <Route path="/forgotPassword" component={forgotPassword} />
                                            <Route path="/resetPassword/:username/:emailtoken" component={ResetPassword} />
                                            <Route path="/resetPassword/:username" component={ResetPassword} />
                                            <Route path="/EMarketStorefrontReturn/" component={EMarketStorefrontReturn} />
                                           

                                            <ProtectedRoute path="/dashboard" component={Dashboard} />

                                        
                                            <ProtectedRoute path="/courses/:course/code" component={EnterCode} />
                                            <ProtectedRoute path="/courses/Zoom" component={SelectCourseZoom} />
                                            <ProtectedRoute path="/courses/DVD" component={SelectCourseDVD} />
                                            <ProtectedRoute path="/courses/Online" component={SelectCourse} />

                                            <ProtectedRoute path="/training/viewQuiz/:id" component={ViewQuiz} />
                                            <ProtectedRoute path="/training/:id" component={ViewSubModule} />
                                            <ProtectedRoute path="/training" component={Training} />
                                            <ProtectedRoute path="/zoomClass/" component={ZoomClass} />

                                            <ProtectedRoute path="/lms/reviewQuiz/:id" component={ReviewQuiz} />
                                            <ProtectedRoute path="/lms/:id/quiz" component={Quiz} />
                                            <ProtectedRoute path="/lms/:id" component={Articulate} />

                                            <Route path="/" component={DefaultPage} />

                                        </Switch>
                                    </Box>
                                    <Footer />
                                </Box>
                                {
                                    this.state.showIdleDlg
                                    ?
                                    <IdleDialog
                                    open={this.state.showIdleDlg}
                                    onStay={this.onStay}
                                    onLogout={this.onLogout}
                                />
                                    :
                                    <></>
                                }
                                
                            </Fragment>
                        </Auth>
                    </Router>
                </Suspense>
            </ErrorBoundary>
        );
    }
}

function DefaultPage(){
    return <h1>Page does not exist</h1>
}

export default withStyles(styles, { withTheme: true })(App);
//export default withStyles(styles, { withTheme: true }) (withIdleTimer(App));
